export default __webpack_public_path__ + "340d12a78eeec1d3f16840bc451d109e.png";